import i18n from "i18next";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Divider } from "@mui/material";

/**
 * Plugin menu in the editor's navbar
 */
export default class PluginsMenu extends Component {
  /**
   * Constructor
   */
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      alert: undefined,
      open: false,
      anchorEl: null,
    };
  }

  /**
   * Click on plugin category callback
   */
  openPlugin(category) {
    this.props.setcat(category);
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    let categories = [
      /* {
                name: 'image',
                displayName: i18n.t("Images"),
                icon: 'image',
            },*/
      {
        name: "text",
        displayName: i18n.t("Text"),
        icon: "text_fields",
      },
      {
        name: "multimedia",
        displayName: i18n.t("Multimedia"),
        icon: "play_circle_outline",
      },
      {
        name: "objects",
        displayName: i18n.t("Objects"),
        icon: "unarchive",
      },
      {
        name: "evaluation",
        displayName: i18n.t("Evaluation"),
        icon: "school",
      },
    ];
    return (
      <div className="pluginsMenu" onClick={() => this.openPlugin("")}>
        {categories.map((cat, ind) => {
          if (this.state.categories.indexOf(cat.name) > -1) {
            return (
              <button
                key={ind}
                className={
                  this.props.hideTab === "show" && this.props.category === cat.name
                    ? "navButtonPlug active"
                    : "navButtonPlug"
                }
                title={cat.displayName}
                disabled={false /* disablePlugins*/}
                onClick={(e) => {
                  this.props.category === cat.name
                    ? this.openPlugin("")
                    : this.openPlugin(cat.name);
                  e.stopPropagation();
                }}
              >
                <i className="material-icons showonresize">{cat.icon}</i>
                <span className="hideonresize"> {cat.displayName}</span>
              </button>
            );
          }
          return null;
        })}
        <Divider style={{ borderLeft: "1px solid #bbb", height: "66%" }} />

        <div id="dropdown-menu" style={{ marginLeft: "10px", width: "100px" }}>
          <button
            className={
              this.props.hideTab === "show" && this.props.category === "library"
                ? "navButtonPlug active"
                : "navButtonPlug"
            }
            title={i18n.t("Library")}
            disabled={false /* disablePlugins*/}
            onClick={() => {
              this.props.toggleFileUpload(undefined, "*");
            }}
          >
            <i className="material-icons showonresize" style={{ fontSize: "20.4px" }}>
              {"account_balance"}
            </i>
            <span
              className="hideonresize"
              style={{ fontSize: "13px", fontWeight: "500", marginLeft: "5%" }}
            >
              {i18n.t("Library")}
            </span>
          </button>
        </div>
      </div>
    );
  }

  componentDidMount() {
    // Only will show categories that have at least one plugin inside
    let categories = [];
    let plugins = IdealStudio.Plugins.getPluginConfigs();
    for (let plug in plugins) {
      if (categories.indexOf(plugins[plug].category) === -1) {
        categories.push(plugins[plug].category);
      }
    }
    // Always add 'audio' category for the Audio plugin
    if (categories.indexOf("audio") === -1) {
      categories.push("audio");
    }
    this.setState({ categories });
  }
}

PluginsMenu.propTypes = {
  /**
   * Plugin's category shown
   */
  category: PropTypes.string.isRequired,
  /**
   * Toggles the plugin bar's visibility
   */
  hideTab: PropTypes.oneOf(["show", "hide"]).isRequired,
  /**
   * Changes the chosen plugin category
   * */
  setcat: PropTypes.func.isRequired,
};
